<template>
  <div id='hj-container'>
    <header-layout activeIndex="joinUs"></header-layout>
    <div class="joinUs-bg2">
      <img src="../../assets/img/joinUs/joinUs_02.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/joinUs/joinUs_04.jpg" class="bg2-rowImg" width="100%"/>
      <div class="box">
        <!-- 地图组件 -->
        <el-amap
          vid="amapContainer"
          :zoom="zoom"
          :events="events"
          class="amapClass"
        ></el-amap>

        <div class="card-list">
          <div class="card-row card1">
            <div class="icon-row">
              <div>
                <div class="icon-row-1">PHONE</div>
                <div class="icon-row-2">联系电话：</div>
              </div>
              <div class="iconStyle">
                <div class="icon-1"></div>
              </div>
            </div>
            <div class="row-word">021-50112219</div>
          </div>
          <div class="card-row card2">
            <div class="icon-row">
              <div>
                <div class="icon-row-1">ADDRESS</div>
                <div class="icon-row-2">公司地址：</div>
              </div>
              <div class="iconStyle">
                <div class="icon-2"></div>
              </div>
            </div>
            <div class="row-word">上海市浦东新区金海路1000号26号楼12层</div>

          </div>
          <div class="card-row card3">
            <div class="icon-row">
              <div>
                <div class="icon-row-1">EMALL</div>
                <div class="icon-row-2">联系邮箱：</div>
              </div>
              <div class="iconStyle">
                <div class="icon-3"></div>
              </div>
            </div>
            <div class="row-word">SERVICE@INSURESMART.COM.CN</div>

          </div>
        </div>
      </div>
      <img src="../../assets/img/joinUs/joinUs_06.jpg" class="bg2-rowImg" width="100%"/>
      <div class="join-form">
        <el-form label-position="top" label-width="80px" :model="formData" inline>
          <el-row>
            <el-col :span="12">
              <el-form-item label="您的姓名">
                <el-input v-model="formData.name" style="width: 500px" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="您的电话">
                <el-input v-model="formData.phone" style="width: 500px" placeholder="请输入您的电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所需服务">
                <el-input v-model="formData.server" style="width: 500px" placeholder="请输入所需服务">></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="你的邮箱">
                <el-input v-model="formData.email" style="width: 500px" placeholder="请输入你的邮箱">></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="需求描述">
                <el-input v-model="formData.description" style="width: 1070px" :rows="5" type="textarea"
                          placeholder="请输入您的需求描述"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="mb30 mt10">
        <el-button class="button-form" @click="formSubmit">提交信息</el-button>
      </div>

    </div>


    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue';
import FooterLayout from '@/components/pc/FooterLayout.vue';
import {lazyAMapApiLoaderInstance} from "vue-amap";

export default {
  name: "",
  components: {HeaderLayout, FooterLayout},
  data() {
    return {
      map: null, // 地图实例存储变量
      zoom: 16, // 地图缩放比例。zoom值越小，越宏观、越大，越微观。大家可以更改zoom值看看效果
      events: {}, // 地图事件
      x: 121.62013,
      y: 31.263027,
      formData: {
        description: '',
        name: '',
        phone: '',
        email: '',
        server: '',
      },
    }
  },
  mounted() {
    // 插件加载成功以后去绘制地图
    lazyAMapApiLoaderInstance.load().then(() => {
      // 指定地图容器，并做相应的配置
      this.map = new AMap.Map("amapContainer", {
        center: new AMap.LngLat(this.x, this.y), // 地图中心点的经纬度位置配置
        zoom: this.zoom, // 地图缩放比例配置
      });
      // 标记的配置
      var marker = new AMap.Marker({
        map: this.map, // 使用此地图实例
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png", // 标记定位的小图标
        position: [this.x, this.y], // 标记定位的小图标经纬度位置（一般标记定位的位置和地图中心点的位置要保持一致）
      });
      // 使用相关配置
      marker.setMap(this.map);
    });
  },
  methods: {
    formSubmit() {
      this.$message({
        message: '提交成功！',
        type: 'success'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
#hj-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.joinUs-bg2 {
  width: 100%;
}

.box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 300px;
}

/* 指定地图的宽高 */
.amapClass {
  width: 100%;
  height: 500px;
}

.card-list {
  margin-top: 40px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  text-align: left;

  .card-row {
    background-color: #EDEDED;
    width: 25%;
    height: 110px;
    padding: 30px 50px;
    border-radius: 8px;
  }

  .icon-row {
    display: flex;
    align-content: center;
    justify-content: space-between;
    height: 60px;
    border-bottom: 1px #999999 dashed;


    .icon-row-1 {
      font-weight: 600;
      line-height: 25px;
      font-size: 18px;
    }

    .icon-row-2 {
      line-height: 25px;
      font-size: 14px;
    }

    .iconStyle {
      width: 35px;
      height: 35px;
      border-radius: 20px;
      border: 1px #999999 solid;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-1 {
        width: 15px;
        height: 15px;
        background-image: url("../../assets/img/joinUs/icon-b2.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .icon-2 {
        width: 15px;
        height: 20px;
        background-image: url("../../assets/img/joinUs/icon-b1.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .icon-3 {
        width: 20px;
        height: 15px;
        background-image: url("../../assets/img/joinUs/icon-b3.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }

  .row-word {
    line-height: 50px;
    font-weight: 600;
  }


  .card1 {
    &:hover {
      transition: all 1000ms ease;
      background-color: #F69734;
      color: #ffffff;

      .icon-row {
        border-bottom: 1px #ffffff dashed;
      }

      .iconStyle {
        border: 0px #ffffff solid;
        background-color: #ffffff;
      }

      .icon-1 {
        background-image: url("../../assets/img/joinUs/icon-l2.png");
      }
    }
  }

  .card2 {
    &:hover {
      transition: all 1000ms ease;
      background-color: #F69734;
      color: #ffffff;

      .icon-row {
        border-bottom: 1px #ffffff dashed;
      }

      .iconStyle {
        border: 0px #ffffff solid;
        background-color: #ffffff;
      }

      .icon-2 {
        background-image: url("../../assets/img/joinUs/icon-l1.png");
      }
    }
  }

  .card3 {
    &:hover {
      transition: all 1000ms ease;
      background-color: #F69734;
      color: #ffffff;

      .icon-row {
        border-bottom: 1px #ffffff dashed;
      }

      .iconStyle {
        background-color: #ffffff;
        border: 0px #ffffff solid;

      }

      .icon-3 {
        background-image: url("../../assets/img/joinUs/icon-l3.png");
      }
    }
  }
}

.join-form {
  text-align: left;
  width: 60%;
  margin: 0 18% 0 22%;
  font-weight: bold;

}

.button-form {
  font-size: 16px;
  width: 150px;
  height: 45px;
  color: #ffffff;
  background-color: #F69734;
  border-radius: 20px;
}
</style>
